import type { StatusVariantMap } from '@zafroi/ui-kit';

export const quoteStatusVariants: StatusVariantMap = {
  DRAFT: { label: 'Draft', tone: 'neutral' },
  SENT: { label: 'Sent', tone: 'info' },
  ACCEPTED: { label: 'Accepted', tone: 'success' },
  REJECTED: { label: 'Rejected', tone: 'destructive' },
  EXPIRED: { label: 'Expired', tone: 'neutral' },
  CONVERTED: { label: 'Converted', tone: 'success' },
};

export const proposalStatusVariants: StatusVariantMap = {
  DRAFT: { label: 'Draft', tone: 'neutral' },
  SENT: { label: 'Sent', tone: 'info' },
  UNDER_REVIEW: { label: 'Under review', tone: 'warning' },
  ACCEPTED: { label: 'Accepted', tone: 'success' },
  REJECTED: { label: 'Rejected', tone: 'destructive' },
  EXPIRED: { label: 'Expired', tone: 'neutral' },
  CONVERTED: { label: 'Converted', tone: 'success' },
};

export const catalogStatusVariants: StatusVariantMap = {
  DRAFT: { label: 'Draft', tone: 'neutral' },
  ACTIVE: { label: 'Active', tone: 'success' },
  DEPRECATED: { label: 'Deprecated', tone: 'warning' },
  ARCHIVED: { label: 'Archived', tone: 'neutral' },
};

export const reminderStatusVariants: StatusVariantMap = {
  SCHEDULED: { label: 'Scheduled', tone: 'info' },
  SENT: { label: 'Sent', tone: 'success' },
  FAILED: { label: 'Failed', tone: 'destructive' },
  CANCELLED: { label: 'Cancelled', tone: 'neutral' },
};
